import axios from 'axios';

/**
 * --------------------------------------------------------------- GET Method
 * 获取项目列表
 */
export const getProjects = () => {
  return axios.get('/api/v2/projects');
};

export const getProjectsHierarchy = () => {
  return axios.get('/api/projects');
};

/**
 * 获取已上传的项目展示图列表
 */
export const getBanners = ({ projectId }) => {
  return axios.get(`/api/projects/${projectId}/banners`);
};

/**
 *获取项目下分页设备
 */
export const getProjectDevs = ({ id, type, page, size, deviceNamePattern }) => {
  const params = { type, page, size, deviceNamePattern };
  return axios.get(`/api/projects/${id}/devs`, { params });
};


/**
 * 获取项目下分组设备
 */
export const getGroupedDevs = ({ id, type, branchId, departmentId }) => {
  const params = { type, branchId, departmentId };
  return axios.get(`/api/projects/${id}/groupedDevs`, { params });
};


/**
 * 获取项目下可用设备类型
 * @param {*} id
 */

export const getDeviceTypes = (id) => {
  return axios.get(`/api/projects/${id}/deviceTypes`);
};

/**
 * --------------------------------------------------------------- PATCH Method
 * 更新项目属性
 */
export const updateProject = (params) => {
  return axios.patch(`/api/projects/${params.id}`, params);
};


/**
 * --------------------------------------------------------------- POST Method
 * 创建项目
 */
export const createProject = (params) => {
  return axios.post('/api/projects', params);
};


/**
 * 设置项目首页的展示图
 */
export const setBanner = (params) => {
  const { projectId } = params;
  delete params.projectId;
  return axios.post(`/api/projects/${projectId}/banner`, params);
};


/**
 * --------------------------------------------------------------- DELETE Method
 * 删除项目
 */
export const deleteProject = (params) => {
  return axios.delete(`/api/projects/${params.id}`);
};


/**
 * 删除项目展示图
 */
export const deleteBanner = ({ projectId, filename }) => {
  return axios.delete(`/api/projects/${projectId}/banners?filename=${filename}`);
};

